import { createAction } from 'redux-actions';

export const setCreateWalletStep = createAction('auth/set/createWalletStep', step => ({ step }));
export const setLwAction = createAction('auth/set/lwService', lw => ({ lw }));
